import React from 'react';
import classnames from 'classnames';
import { InputSwitch } from 'primereact/inputswitch';
import { ISwitch } from './Switch.types';

export const Switch: React.FC<ISwitch> = ({ checked, onChange, className, ...restProps }) => {
  const classNames = classnames(className);

  return <InputSwitch className={classNames} {...restProps} checked={checked} onChange={(e) => onChange(e.value)} />;
};
